import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Applicant } from '../../models/applicant.model';
import { HttpCERS } from '../cers.api';

@Injectable({
  providedIn: 'root'
})
export class ApplicantService {

  constructor(private api: HttpCERS) {
    this.api = api.setContext('/applicant');
    this.api.setLocalContext('', 'http://localhost:8242');
  }

  create(applicant: Applicant): Observable<Applicant> {
    return this.api.post('/', applicant);
  }

  findById(id: number): Observable<Applicant> {
    return this.api.get(`/${id}`);
  }

  search(email?: string, enabled?: boolean): Observable<Array<Applicant>> {
    return this.api.get('/', { email, enabled });
  }

  verifyToken(token: string): Observable<Applicant> {
    return this.api.get(`/verifify-token/${token}`);
  }

  changePassword(token: string, applicant: Applicant): Observable<any> {
    return this.api.post(`/change-password/${token}`, applicant);
  }

  requestChangePassword(email: string): Observable<any> {
    return this.api.post('/requestResetPassword', email);
  }

}
